import React, { useMemo } from 'react';
import { connect } from "react-redux";
import LoadingBox from "../../../components/LoadingBox";
import { AppState, getStore } from "../../../util/store/store";
import { OPERATION_TYPE, STEP_KEY_V2 } from "../../../util/varibles/constants";
import { IOperation, IOperation2 } from "../../../util/varibles/interface";
import { messageActions } from "../../MessagePage/reducer";
import { opDetailActions } from "../reducer";
import Event from "./Event";
// import Harvest from "./Harvest";
import { selectTenantId } from '../../../util/store/selectors';
import Harvest from "./Harvest2";
import Service from "./Service";
import Service2 from './Service2';
import styles from './style.module.scss';
import Support from './Support';
import Transport from "./Transport";
import Treatment from "./Treatment";
import Treatment2 from './Treatment2';

const mapStateToProps = (state: AppState) => {
    return {
        data: state.operationDetail.data,
        loading: state.operationDetail.loadingOp,
    }
};

interface IProps {
    data: IOperation
    loading: boolean
}

const Detail: React.FC<IProps> = (props) => {
    const { data, loading } = props;

    const op = useMemo(() => {
        const { operation } = data as IOperation2 || {};
        const { tenant_id } = operation || {};
        const userTenantId = selectTenantId(getStore());
        const common = {
            isOwn: tenant_id === userTenantId,
        }

        switch (operation?.operation_type) {
            case OPERATION_TYPE.HARVEST: {
                const { site, factory } = operation;
                return <Harvest {...common} data={{ ...data, operation: { ...operation, source: site, destination: factory } }} />
            }
            case OPERATION_TYPE.TRANSPORT: {
                return <Transport {...common} data={{ ...data, operation }} />
            }
            case OPERATION_TYPE.TREATMENT: {
                const indexes = new Set<number>([0, 1, 2]);
                const index = data.activity_log.findIndex(item => item.key === STEP_KEY_V2.TREATING)
                if (indexes.has(index))
                    return <Treatment2 {...common} data={{ ...data, operation }} />;
                else
                    return <Treatment {...common} data={{ ...data, operation }} />
            }
            case OPERATION_TYPE.EVENT: {
                return <Event {...common} data={{ ...data, operation }} />
            }
            case OPERATION_TYPE.SERVICE: {
                if (data.activity_log.length > 2) {
                    return <Service2 {...common} data={{ ...data, operation }} />
                } else
                    return <Service {...common} data={{ ...data, operation }} />
            }
            case OPERATION_TYPE.SUPPORT: {
                return <Support {...common} data={{ ...data, operation }} />
            }
            default:
                return <LoadingBox loading={loading} level='page' />
        }
    }, [data, loading]);

    return <div className={styles.detail}>
        <div className={styles.content} data-loading={loading} data-empty={!op || data?.operation?.operation_type === undefined}>
            {op}
        </div>
    </div>
};

export default connect(mapStateToProps, {
    updateOp: opDetailActions.updateOp,
    getMessages: messageActions.getMessagesRequest
})(Detail)
